<template>
  <div class="SubscriptionPurchase">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        class="fullscreen"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>

    <template v-else>
      <section class="SubscriptionPurchase_header">
        <div class="ShoppingCart container">
          <h2 class="title">
            {{ $t('subscription_purchase.title', 'Shopping Cart') }}
          </h2>

          <product
            :sbeflag = {sbeflag}
            :name="tryBuyRatePlan.name"
            :image="tryBuyRatePlan.imageUrl"
            :purchase-charge="{
              original: tryBuyRatePlan.purchaseValueToPay,
              discounted: tryBuyRatePlan.discountedPurchaseValueToPay
            }"
          />
        </div>
      </section>

      <template>
        <section class="SubscriptionPurchase_body SubscriptionPurchase_body-selectPaymentMethod">
          <div class="container">
            <div class="wrapper-top">
              <h2 class="title">
                {{ $t('subscription_purchase.paymentMethod.title', 'Select payment method') }}
              </h2>
            </div>

            <payment-methods
              :sbeflag = {sbeflag}
              :payment-method-submit-active="false"
              @payment-method-selected="setPaymentMethod($event)"
            >
              <p slot="payment-footer">
                {{ $t('myaccount.paymentDetails.notificationForMethodChange', 'Please note that the payment method and details you use for this payment will be used for future recurring payments. You can change your payment method and details at any time in the "Payment Details" section in your Account.') }}
              </p>
            </payment-methods>
          <div id="payment-page" class="payment-page-adyen">
          <div class="container">
           <div class="payment-container demo">
             <div id="dropin-container">
            </div>
           </div>
          </div>
          </div>
          </div>
        </section>

        <section class="SubscriptionPurchase_footer SubscriptionPurchase_footer-selectPaymentMethod">
          <div class="container">
            <app-checkbox
              id="purchase-terms"
              v-if= !taskIsActive
              :value="isAgree"
              @input="isAgree = $event"
              :label="$t('subscription_purchase.paymentDetail.checkBox.terms.label', 'By placing the order l confirm that l have read and agree to the')"
              @click="trackConversion({name: 'interaction', description: `agree_to_the_terms:${isAgree ? 'uncheck' : 'check' }`})" >
              <a
                class="link"
                @click.prevent="$bus.$emit('open-modal')"
              >
                {{ $t('subscription_purchase.paymentDetail.checkBox.terms.text', 'terms') }}
              </a>
            </app-checkbox>

            <app-modal name="purchaseTerms">
              <div class="v--modal-content" v-html="termsAndCconditions"></div>
            </app-modal>

            <app-button
              type="submit"
              @click.prevent="payInFullWithChangePaymentMethodTask.run()"
              :is-loading="taskIsActive"
              data-name="SubscriptionPurchase-submitButton"
              :disabled="(taskIsActive || !(isAgree && paymentMethodCode)) && !paymentActivity.hasPaymentInProgress"
              :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
              @mouseleave="mouseleave"
              @mouseover="mouseover"
              v-if= !taskIsActive
            >
              {{ $t('subscription_purchase.paymentDetail.button', 'pay in full now') }} ›
            </app-button>
            <v-popover
              offset="15"
              trigger="manual"
              placement="bottom-right"
              :open="isOpen"
              popover-wrapper-class="purchase_poptip"
            >
              <template slot="popover">
                <div>{{ $t('common.paymentInprogress.toolTips.text', 'This option is disabled as we are processing your latest payment') }}</div>
              </template>
            </v-popover>

            <!-- <p class="tips-security">
              {{ $t('checkout.payment.secureType', 'You will be redirected to a secure checkout page.') }}
            </p> -->

            <div ref="paymentForm" v-html="paymentForm" v-show="false"></div>
          </div>
        </section>
      </template>
    </template>

     <!-- <template v-if="currentCountryCode === 'GB' && sbeCompliance !== 'True' || currentCountryCode === 'NL' && sbeCompliance !== 'True' || currentCountryCode === 'DE' && sbeCompliance !== 'True'">
        <app-modal name="sbecompliancemodal" :clickToClose="false" width="500px">
              <div class="v--modal-content">
                <div class="newFlowForCancelReplenishment_popUp" >
                  <div class="sbeTC" v-html="$t('checkout.noPayment.button.decline.sbeterms')"> </div>
                  <div class="modal-button-wrapper"> 

                    <app-button
                        data-name="AcceptDue" 
                        @click="Acceptpaymentdue"
                          class="AppButton"
                        >
                      {{ $t('checkout.noPayment.button.confirmOrder.sbe', 'Confirm') }}
                    </app-button> 
                  </div> 
                </div>
              </div>
        </app-modal>
      </template>  -->
  </div>
</template>

<script>
  import Vue from 'vue'
  import Product from 'components/Product'
  import PaymentGeneralMixin from 'mixins/payment-general'
  import { extractErrorMessage } from '@/utilities/common'
  import { detectedCulture } from 'utilities/common/culture'
  import { find } from 'lodash'
  import { mapGetters,mapState} from 'vuex'
  import AdyenCheckout from '@adyen/adyen-web';
  import '@adyen/adyen-web/dist/adyen.css'; 

  export default {
    name: 'subscription-purchase',

    components: {
      Product
    },

    mixins: [PaymentGeneralMixin],

    data () {
      return {
        subscriptionNumber: this.$route.params.id,
        promotionCode: this.$route.query.coupon,
        tryBuyRatePlan: {},
        isAgree: false,
        termsAndCconditions: this.$t('common.purchase.termsAndConditions'),
        cancelPaymentUrl: window.location.href,
        currentCountryCode: detectedCulture.countryCode,
        isOpen: false,
        sbeflag: 'NA'
      }
    },

    computed: {
      ...mapGetters('account', ['paymentActivity']),
       ...mapState('account', { 
        sbeCompliance: state => state.profile.personalDetail.sbeCompliance
       }) 
    },

    methods: {
      Acceptpaymentdue(){
         this.$bus.$emit('close-modal', 'sbecompliancemodal') 
         this.sbeflag = 'True'
         this.$store.commit('account/setsbeCompliance','True')
       }, 
       Deniedpaymentdue(){
        this.$bus.$emit('close-modal', 'sbecompliancemodal') 
        this.sbeflag = 'False'
        this.$store.commit('account/setsbeCompliance','False') 
       },
      mouseleave () {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = false
        }
      },
      mouseover () {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = true
        }
      }
    }, 

    async created () {
      try {
        const { ratePlans, purchaseTermsAndConditions } = await Vue.api.subscription.getSubscriptionDetailsById(this.subscriptionNumber)
        this.tryBuyRatePlan = find(ratePlans, { modelType: 'TryBuy' }) || find(ratePlans, { modelType: 'TryBuyDepreciation' })
        if (purchaseTermsAndConditions) {
          this.termsAndCconditions = purchaseTermsAndConditions
        }
        if (this.tryBuyRatePlan) {
          Promise.all([
            Vue.api.subscription.payInFullPreview(this.subscriptionNumber, this.tryBuyRatePlan.id, this.promotionCode).then(data => {
              this.tryBuyRatePlan.discountedPurchaseValueToPay = data.discountedAmount
            }),
            this.$store.dispatch('account/fetchMyPaymentMethod')
          ]).then(() => {
            this.isLoading = false
          }).catch(error => {
            this.$notify({
              type: 'error',
              title: extractErrorMessage(error)
            })
          })
        } else {
          this.$notify({
            type: 'error',
            title: this.$t('subscription_purchase.popuptips.status.purchased', 'This product has already been purchased!'),
            duration: 3000
          })
          setTimeout(() => {
            this.$router.replace({ name: 'overview' })
          }, 4000)
        }
      } catch (error) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      }
    },

    tasks (t) {
      return {
        payInFullWithChangePaymentMethodTask: t(async function () {
          this.taskIsActive = true
          if (this.paymentActivity.hasPaymentInProgress) {
            this.taskIsActive = false
            return false
          } 
           let provider = this.paymentMethodCode.split('.')[0]
           if (provider === 'Adyen') {
          await await Vue.api.account.payInFullWithChangePaymentMethod(this.subscriptionNumber, this.tryBuyRatePlan.id, this.promotionCode, this.paymentMethodCode, this.cancelPaymentUrl,this.sbeCompliance).then(data => {
          localStorage.setItem('ordernumber', data.orderNumber);
          localStorage.setItem('amount', data.amount);
         }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
     
        await Vue.api.account.adyenpayinfull(provider, this.paymentMethodCode, this.sbeCompliance, window.localStorage.getItem('ordernumber'), window.localStorage.getItem('amount')).then(data => {
        localStorage.setItem('sessionID', data.id);
        localStorage.setItem('sessiondata', data.session);
        localStorage.setItem('Client', data.clientKey);
        localStorage.setItem('Env', data.environment);
       
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
      debugger
   let brandcode =  this.paymentMethodCode.split('.')[1]
   const cardConfiguration = {
   hasHolderName: true,
   holderNameRequired: true,
   brands:[brandcode],
   
};
  const configuration = {
  environment: window.localStorage.getItem('Env'),
  clientKey: window.localStorage.getItem('Client'),
  showPayButton: true,
  session: {
    id: window.localStorage.getItem('sessionID'), 
    sessionData: window.localStorage.getItem('sessiondata'),
   
  },
  onPaymentCompleted: (result, component) => {

   if(result.resultCode === 'Authorised'){

     window.location.href = `${window.location.origin}/${this.$router.options.base}/my-account/subscription-thankyou/${this.$route.params.id}`
            } else {
              window.localStorage.setItem('changePaymentAndPayInfullResult', 'failed')
              window.location.href = `${window.location.origin}/${this.$router.options.base}/my-account/subscription-details/${this.$route.params.id}`
            }

      console.info(result, component);
  },
  onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
  },
 
  paymentMethodsConfiguration: {
    card: cardConfiguration
  }
};

// Create an instance of AdyenCheckout using the configuration object.
const checkout = await AdyenCheckout(configuration);

// Create an instance of Drop-in and mount it to the container you created.
const dropinComponent = checkout.create('dropin').mount('#dropin-container');

           
      // window.location.href = `${window.location.origin}/${this.$router.options.base}/pastdue-adyenpayment`
          }
          
          else {
            const { htmlForm } = await Vue.api.account.payInFullWithChangePaymentMethod(this.subscriptionNumber, this.tryBuyRatePlan.id, this.promotionCode, this.paymentMethodCode, this.cancelPaymentUrl,this.sbeCompliance)
            this.paymentForm = htmlForm
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
          this.taskIsActive = false
        }).flow('drop')
      }
    },
      mounted () { 
        if(this.currentCountryCode === 'US' || this.currentCountryCode === 'CA' || this.currentCountryCode === 'PL' ){
        this.sbeCompliance = 'NA'
      }
       if(this.currentCountryCode === 'AT' || this.currentCountryCode === 'IT' || this.currentCountryCode === 'BE' || this.currentCountryCode === 'ES'  ){
        this.sbeCompliance = 'True'
      }
        setTimeout(() => {
          this.$bus.$emit('open-modal', 'sbecompliancemodal')
        }, 1000);  
    }  
  }
</script>

<style lang="scss">
  .SubscriptionPurchase {
    .PaymentMethod {
      &_wrapper {
        background: rgb(255 255 251);
        margin-bottom: -.3rem;
      }
    }

    .demo {
      width: 40%;
      margin-left: -11px;
    }

    .adyen-checkout__card__cardNumber__input {
      width: 100%;
    }

    .adyen-checkout__field--expiryDate {
      width: 48%;
    }

    .adyen-checkout__field__cvc {
      width: 48%;
    }

    .adyen-checkout__card__holderName {
      width: 100%;
    }

    .adyen-checkout__button--pay {
      width: 100%;
    }

    .adyen-checkout__payment-method--selected {
      background: #f7f8f9;
      border: 1px solid #e6e9eb;
      border-radius: 12px;
      cursor: default;
      margin: 8px 0;
    }

    .adyen-checkout__payment-method {
      background: #f7f8f9;
      border: 1px solid #e6e9eb;
      cursor: pointer;
      margin-top: -1px;
      position: relative;
      transition: opacity .3s ease-out;
      width: 100%;
      height: 400px;
    }

    &_header {
      padding: .2rem 0 .25rem;
      background-color: $block-bg;
      margin-bottom: .25rem;

      @include media(tablet) {
        padding: .2rem 0 0;
        background-color: transparent;
        background-image: url(../assets/images/checkout-banner-img.png);
        background-size: 100% 101%;
      }

      .ShoppingCart {
        .title {
          margin-bottom: .15rem;
        }

        .Product {
          padding: .1rem;
          background: $white;
          border: .01rem solid #e8e8e8;

          .Product_name {
            font-size: .18rem;
            font-weight: 700;
            color: $font-black;
          }

          .Product_price {
            font-size: .28rem;
            line-height: 1.15;
            color: $font-black;
          }

          @include media(tablet) {
            padding: .2rem;
          }
        }
      }
    }

    &_body {
      margin-bottom: .25rem;

      .title {
        padding: 0 .15rem .12rem;
        border-bottom: 0.01rem solid #9b9b9b;
      }

      .Form_group {
        margin-bottom: 0;

        .Form_label {
          font-size: .16rem;
          color: #666;
          line-height: .25rem;
          padding: .1rem .15rem 0;
        }

        .Form_control {
          font-size: .18rem;
          line-height: .25rem;
          padding: 0 .15rem .1rem;
        }
      }

      &-selectPaymentMethod {
        .wrapper-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 .1rem .15rem;

          @include media(tablet) {
            padding: 0 .15rem .15rem;
          }
        }

        .title {
          padding: 0;
          border: none;
        }
      }

      .payment-tips {
        font-weight: 500;
        margin-bottom: .15rem;
      }
    }

    &_footer {
      margin-bottom: .3rem;

      .Form_group-choice {
        margin-bottom: .25rem;
        padding: 0 .15rem;
      }

      .AppButton {
        width: 100%;
      }

      .wrapper-a {
        text-align: center;
        padding: .19rem 0;

        a {
          color: $blue;
        }
      }

      .tips-security {
        padding: .1rem .05rem;
        font-size: .12rem;
        text-align: center;
      }

      &-selectPaymentMethod {
        .Form_group-choice {
          padding: 0 .1rem;

          @include media(tablet) {
            padding: 0 .15rem;
          }
        }
      }
    }

    .grey-color {
      background: #d8d8d8 !important;
      cursor: default;
    }

    .sbeTC {
      font-weight: 700;
    }

    ul {
      margin: 0.1rem 0.2rem 0.2rem 0.2rem;
    }

    ul li {
      display: block;
      height: 15px;
    }

    .modal-button-wrapper {
      display: flex;
      overflow: hidden;
    }

    .AppButton {
      margin: 0 auto;
      width: 2 rem;
      min-width: 2rem;
    }

    .newFlowForCancelReplenishment_popUp {
      .modal-title {
        margin: 0.2rem 0;
        text-align: left;
      }
    }

    .v--modal-box {
      .closeButton {
        display: none;
      }
    }
  }

  .purchase_poptip {
    top: -.33rem;
    left: .2rem;
    position: absolute;
    background: white;
    min-width: 2.09rem;

    @include media(tablet) {
      top: -.33rem;
      left: 6rem;
      position: absolute;
      background: white;
      min-width: 2.26rem;
    }

    .tooltip-arrow {
      @include media(tablet) {
        left: calc(20% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(20% - 9px) !important;
      }
    }
  }
</style>
